export const baseTileStyling =
  "before:absolute before:content-[''] before:rounded before:border-solid before:inset-0 before:z-5";

export const baseTileBorderStyling = "before:border before:border-gray-600";

export const baseTileHoverStyling =
  "[@media(hover:hover)]:hover:before:border-2 [@media(hover:hover)]:hover:before:border-gray-700 focus:outline focus:outline-3 focus:outline-offset-[-3px] focus:outline-transparent";

export const selectedTileBorderStyling =
  "before:border-2 before:border-blue-400";
